import { Routes } from '@angular/router';

import { HypeComponent } from '../../Common/Layout/components/Hype/hype.component';
import { ViMonitorSetupComponent } from '../components/ViMonitorSetup/vi-monitor-setup.component';
import { ViReportsComponent } from '../components/ViReports/vi-reports.component';
import { ViResultsShellComponent } from '../components/ViResultsShell/vi-results-shell.component';
import { ViQueriesAndAnswersComponent } from '../components/ViQueriesAndAnswers/vi-queries-and-answers.component';
import { ViRouteType } from '../enums/vi-route-type.enum';
import { ViMonitorSetupDeactivateGuard } from './vi-monitor-setup-deactivate.guard';
import { ViMonitorEditableGuard } from './vi-monitor-editable.guard';
import { ViMonitorHasResultsGuard } from './vi-monitor-has-results.guard';

export const visibilityIntelligenceRoutes: Routes = [
    {
        path: '',
        component: HypeComponent,
        data: { viRoute: ViRouteType.HYPE, title: 'VisibilityIntelligence.browserTitle' }
    },
    {
        path: 'new',
        component: ViMonitorSetupComponent,
        canDeactivate: [ViMonitorSetupDeactivateGuard],
        data: { viRoute: ViRouteType.NEW, title: 'VisibilityIntelligence.createMonitor.browserTitle' }
    },
    {
        path: ':id',
        component: ViMonitorSetupComponent,
        canActivate: [ViMonitorEditableGuard],
        canDeactivate: [ViMonitorSetupDeactivateGuard],
        data: { viRoute: ViRouteType.EDIT, title: 'VisibilityIntelligence.createMonitor.browserTitle' }
    },
    {
        path: ':id/results',
        component: ViResultsShellComponent,
        canActivate: [ViMonitorHasResultsGuard],
        children: [
            { path: '', redirectTo: 'reports', pathMatch: 'full' },
            {
                path: 'reports',
                component: ViReportsComponent,
                data: { viRoute: ViRouteType.REPORTS, title: 'VisibilityIntelligence.monitor.browserTitle' }
            },
            {
                path: 'queries-and-answers',
                component: ViQueriesAndAnswersComponent,
                data: { viRoute: ViRouteType.QUERIES_AND_ANSWERS, title: 'VisibilityIntelligence.monitor.browserTitle' }
            },
            { path: '**', redirectTo: 'reports' }, // relative — preserves the id
        ]
    },
    {
        path: '**',
        redirectTo: '/visibility-intelligence'
    }
];
